import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el MegaPack después de comprar?',
    a: 'Recibís acceso al material de forma inmediata para que puedas empezar a usarlo cuanto antes, sin esperas ni trámites.'
  }, {
    q: '¿Para qué nivel educativo está pensado?',
    a: 'Para docentes de escuelas técnicas con orientación aeronáutica, institutos de formación técnica, escuelas de aviación y cátedras universitarias de ingeniería aeronáutica en Argentina.'
  }, {
    q: '¿El material ya tiene actividades y evaluaciones incluidas?',
    a: 'Sí. Cada tomo incluye actividades paso a paso, ejercicios de múltiple choice y una evaluación completa con criterios de corrección. No tenés que construir nada desde cero.'
  }, {
    q: '¿El material es editable?',
    a: 'El material se entrega en formato PDF. Podés abrirlo, imprimirlo y proyectarlo en el aula desde cualquier dispositivo.'
  }, {
    q: '¿Cómo pago?',
    a: 'Podés pagar con tarjeta de crédito o débito, transferencia bancaria o Mercado Pago en pesos argentinos.'
  }, {
    q: '¿Qué incluye el Pack Maestro Avanzado de $27.990?',
    a: 'Incluye los 4 tomos técnicos, los 4 bonos estratégicos y además el banco completo de exámenes EASA y FAA con 500 preguntas cada uno, simulacros cronometrados con hojas de respuestas y el plan de estudio de 75 días integrado. Es la opción ideal si tus alumnos se preparan para certificaciones aeronáuticas internacionales.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tenés 7 días de garantía sin preguntas. Si el material no cumple lo que prometemos, te devolvemos el 100% de tu dinero.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 bg-slate-950" data-id="element-45">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-46">
        <h2 className="text-3xl font-extrabold text-center text-white mb-12" data-id="element-47">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-48">
          {faqs.map((faq, i) => <div key={i} className="border border-slate-800 rounded-2xl overflow-hidden bg-slate-900/60" data-id="element-49">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400 hover:bg-slate-800/40 transition-colors" aria-expanded={openIndex === i} data-id="element-50">
                <span className="font-bold text-white pr-4" data-id="element-51">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-52" />
              </button>

              <AnimatePresence data-id="element-53">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-54">
                    <div className="px-6 pb-5 text-slate-300 leading-relaxed border-t border-slate-800 pt-3" data-id="element-55">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}